// React
import React from 'react';

// Utilities
import { useLabels } from 'utilities/hooks';
import { useWizardNavigationStore } from 'utilities/store';

// Packages
import t from 'prop-types';

// Components

const TitlePreambleComponent = ({ title = null, preamble = null }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { currentItem } = useWizardNavigationStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { label } = useLabels();

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <div className="mb-32 text-teal-100 ">
            <h2 className="t-h2">
                {title ? title : label(currentItem?.item?.labels?.form?.title)}
            </h2>
            {(preamble || currentItem?.item?.labels?.form?.preamble) && (
                <p
                    className="mt-16 t-preamble "
                    dangerouslySetInnerHTML={{
                        __html: preamble
                            ? preamble
                            : label(currentItem?.item?.labels?.form?.preamble),
                    }}
                />
            )}
        </div>
    );
};

TitlePreambleComponent.propTypes = {
    title: t.string,
    preamble: t.string,
};

TitlePreambleComponent.defaultProps = {
    title: '',
    preamble: '',
};

export default TitlePreambleComponent;
